"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "matchTargetSize", {
    enumerable: true,
    get: function() {
        return matchTargetSize;
    }
});
function matchTargetSize() {
    return {
        name: 'matchTargetSize',
        fn: async (middlewareArguments)=>{
            const { rects: { reference: referenceRect, floating: floatingRect }, elements: { floating: floatingElement }, middlewareData: { matchTargetSize: { matchTargetSizeAttempt = false } = {} } } = middlewareArguments;
            if (referenceRect.width === floatingRect.width || matchTargetSizeAttempt) {
                return {};
            }
            const { width } = referenceRect;
            floatingElement.style.width = `${width}px`;
            floatingElement.style.boxSizing = 'border-box';
            return {
                data: {
                    matchTargetSizeAttempt: true
                },
                reset: {
                    rects: true
                }
            };
        }
    };
}
